import * as $runtime from "../runtime.js";
import * as Data$dCoyoneda from "../Data.Coyoneda/index.js";
const $HalogenQ = (tag, _1, _2) => ({tag, _1, _2});
const Initialize = value0 => $HalogenQ("Initialize", value0);
const Finalize = value0 => $HalogenQ("Finalize", value0);
const Receive = value0 => value1 => $HalogenQ("Receive", value0, value1);
const Action = value0 => value1 => $HalogenQ("Action", value0, value1);
const Query = value0 => value1 => $HalogenQ("Query", value0, value1);
const functorHalogenQ = {
  map: f => m => {
    if (m.tag === "Initialize") { return $HalogenQ("Initialize", f(m._1)); }
    if (m.tag === "Finalize") { return $HalogenQ("Finalize", f(m._1)); }
    if (m.tag === "Receive") { return $HalogenQ("Receive", m._1, f(m._2)); }
    if (m.tag === "Action") { return $HalogenQ("Action", m._1, f(m._2)); }
    if (m.tag === "Query") {
      const $0 = m._1;
      return $HalogenQ("Query", Data$dCoyoneda.$CoyonedaF(x => f($0._1(x)), $0._2), x => f(m._2(x)));
    }
    $runtime.fail();
  }
};
const bifunctorHalogenQ = {
  bimap: f => g => v => {
    if (v.tag === "Initialize") { return $HalogenQ("Initialize", g(v._1)); }
    if (v.tag === "Finalize") { return $HalogenQ("Finalize", g(v._1)); }
    if (v.tag === "Receive") { return $HalogenQ("Receive", f(v._1), g(v._2)); }
    if (v.tag === "Action") { return $HalogenQ("Action", v._1, g(v._2)); }
    if (v.tag === "Query") {
      const $0 = v._1;
      return $HalogenQ("Query", Data$dCoyoneda.$CoyonedaF(x => g($0._1(x)), $0._2), x => g(v._2(x)));
    }
    $runtime.fail();
  }
};
export {$HalogenQ, Action, Finalize, Initialize, Query, Receive, bifunctorHalogenQ, functorHalogenQ};
